import GeneratePin from './GeneratePin';

export default GeneratePin;
